export enum MapID {
  basic,
  bubbleWrap,
  cinnabar,
  refill,
  street,
  topo,
  tron,
  walkabout,
  openStreetMap,
  openTopoMap,
  cyclOSM,
  satellite,
  outdoors,
}

export const premiumMapIds = new Map([
  [MapID.satellite, "subscription_modal.satellite_map"],
]);
